// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './design-system'; // Wholesale design tokens + primitives CSS
// Shared leaf CSS is hoisted to the entry so it lands in the initial chunk with
// a fixed position in the cascade. Imported from the leaf modules instead, it
// got pulled into many lazily-loaded chunks in conflicting orders, which
// webpack reports as "Conflicting order" and resolves non-deterministically.
import './utils/toast.css';
import './components/shared/CopyEan.css';
import './components/wholesale/shared/ProfitPanel/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './AuthContext'; // Import AuthProvider
import ErrorBoundary from './components/ErrorBoundary'; // Import ErrorBoundary

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();